export default __webpack_public_path__ + "static/media/scan.babb8d9b.png";